<template>
  <div id="app" class="app">
    <div class="header">
      <div class="header__title">Калькулятор Шарарама</div>
    </div>
    <Channels class="content"/>
  </div>
</template>

<script>
import Channels from './components/Channels.vue'

export default {
  name: 'app',
  components: {
    Channels
  }
}
</script>

<style lang="sass">
@import './assets/sass/main'
</style>